/**
 * The API base path.
 *
 * This is a PATH, not an origin, on purpose (§3.4). The refresh cookie is
 * `SameSite=Strict`, so the app and the API must be same-site. Vite proxies
 * `/api` in development and Nginx path-routes it in production. Pointing this
 * at another origin would break authentication in a way that only shows up when
 * the access token first expires.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api';

export function apiUrl(path: string): string {
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${suffix}`;
}
